import React, { Component } from 'react';
import { withRouter, Route } from 'react-router-dom';
import isUrlDifferent from 'jd-library/isUrlDifferent';
import historyHandler from 'jd-library/historyHandler';
import { loadRouteData } from './utills';
import Loader from './common/Loader/Loader';
import Routes from './Routes';
import {initializeHistoryHandler} from './common/historyHandler';
import { matchRoutes } from 'react-router-config';
import querystring from 'querystring';

function parse(search) {
	search = search || '';
	search = search.replace(/^\?/,'');
	return querystring.parse(search.toLowerCase())
}

class PendingNavDataLoader extends Component {
	constructor(props) {
		super(props);
		const hasClientData = this.hasClientData();
		this.state = {
			previousLocation: null,
			currentLocation: this.props.location,
			showRoute: !hasClientData,
			showLoader: hasClientData
		};
	}

	static getDerivedStateFromProps(props, state) {
		const currentLocation = props.location;
		const previousLocation = state.currentLocation;
		const prevParsed = parse(previousLocation.search);
		const curParsed = parse(currentLocation.search);
		const keysToCompare = [
			...Object.keys(prevParsed),
			...Object.keys(curParsed)
		]
		const navigated = isUrlDifferent(previousLocation, currentLocation,keysToCompare);
		if (navigated) {
			// save the location so we can render the old screen
			const routes = matchRoutes(Routes, props.location.pathname);
			const noLoader = routes[0] && routes[0].route.noLoader;

			return {
				previousLocation,
				currentLocation,
				showLoader: !noLoader
			};
		}

		return null;
	}

	componentDidMount(){
		initializeHistoryHandler(this.props.history);
		historyHandler.init(this.props.history);
		if(!this.props.showRoute) {
			try {
				if (this.props.location) {
					loadRouteData(this.props.location, {
						loadType: 'clientData'
					}).then(() => {
						this.setState({
							showRoute: true,
							showLoader: false
						});
					});
				}
			} catch (err) {
				console.log("Error is ", err);
			}
		}
	}

	componentDidUpdate(prevProps) {
		const prevParsed = parse(prevProps.location.search);
		const curParsed = parse(this.props.location.search);
		const keysToCompare = [
			...Object.keys(prevParsed),
			...Object.keys(curParsed)
		]
		const navigated = isUrlDifferent(prevProps.location, this.props.location,keysToCompare);
		if (navigated){
			if (this.props.location.state?.skipDataLoad)  {
				this.setState({
						previousLocation: null,
						showLoader: false
					},() => {
						
					});
				return;
			}
			const loadData = this.handleScrollRest(prevProps);
			if (loadData) {
				// load data while the old screen remains
				loadRouteData(this.props.location).then((data) => {
					// clear previousLocation so the next screen renders
					window && window.scrollTo(0, 0);
					this.setState({
						previousLocation: null,
						showLoader: false
					},() => {
						
					});
				});
			}
		}
	}

	handleScrollRest = (prevProps) => {
		const {
			history,
			location
		} = this.props;
		let loadData = true;
		let isTemp = parse(location.search).istemp;
		let prevTemp = parse(prevProps.location.search).istemp;
		let addEdit = location.pathname.indexOf('edit') != -1 || (location.pathname.indexOf('add') != -1 && isTemp);
		let prevAddEdit = prevProps.location.pathname.indexOf('edit') != -1 || (prevProps.location.pathname.indexOf('add') != -1 && prevTemp);
		if (addEdit && history.action === 'PUSH'){
			this.prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		} else if(prevAddEdit && history.action === 'POP' && typeof this.prevScrollTop != 'undefined'){
			loadData = false;
			this.setState({
				previousLocation: null,
				showLoader: false
			},() => {
				window.scrollTo(0, this.prevScrollTop);
				this.prevScrollTop = 0;
			});
		}
		return loadData
	}

	hasClientData = () => {
		const routes = matchRoutes(Routes, this.props.location.pathname);
		for(let i=0;i<routes.length;i++) {
			if(routes[i].route.clientData) {
				return true;
			}
		}
		return false;
	}
	
	render() {
		const { children, location } = this.props;
		const { previousLocation } = this.state;

		// use a controlled <Route> to trick all descendants into
		// rendering the old location
		return (
			<>
				{this.state.showRoute && (
					<Route
						location={previousLocation || location}
						render={() => children}
					/>
				)}
				{this.state.showLoader ? (
					<Loader />
				) : null}
			</>
		);
	}
}

export default withRouter(PendingNavDataLoader);
